import React from 'react';

export const paymentInformationReviewTitle =
  'Review your direct deposit information';

export const PaymentInformationReviewNote = () => (
  <p>
    <strong>Note:</strong> We’ll also use this account to deposit payments from
    any VA benefits you already receive.
  </p>
);
